module.exports = __webpack_public_path__ + "static/logo-white_transparent-acfb2b5f210ca3f88412c62450987fe2.png";